import React from 'react'
import { ProductOpciones } from '../../components/product'
import { useTraversal } from '@guillotinaweb/react-gmi'

function ProductProperties() {
  const Ctx = useTraversal()

  return (
    <React.Fragment>
      <hr />
      <h3 className="title is-size-6">Opciones</h3>
      <ProductOpciones product={Ctx.context} />
    </React.Fragment>
  )
}

const props = {
  Buttons: null,
  Panels: <ProductProperties />,
}

export default props
